import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

export default function TheBack() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section ref={ref} data-testid="the-back-section" className="relative bg-black text-paper overflow-hidden py-24 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div style={{ y }} className="relative" data-cursor="look">
          <Reveal>
            <img
              src="/images/back-close.webp"
              alt="Close-up of the large illustrated artwork on the back of the SHUTUP T-shirt"
              data-testid="the-back-image"
              className="w-full max-h-[85vh] object-cover object-top border border-white/10"
            />
          </Reveal>
        </motion.div>

        <div>
          <Reveal>
            <p className="font-sans text-turq text-xs font-semibold tracking-[0.35em] mb-8">03 — THE BACK</p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-hindi text-paper text-3xl sm:text-5xl leading-snug" data-testid="the-back-hindi">
              शटअप कोई सलाह नहीं है
              <br />
              बस एक प्रेमपूर्वक दिया गया आदेश है।
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="font-display text-paper/90 text-2xl sm:text-4xl leading-tight mt-10 tracking-wide">
              SHUTUP IS NOT AN ADVICE,
              <br />
              <span className="text-acid">IT IS YOUR REBEL.</span>
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="font-sans text-paper/50 text-sm mt-10 max-w-md leading-relaxed">
              A full illustrated universe on the back of a black oversized silhouette — loud, colourful and strange,
              exactly as intended.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
